class MainProductSelector extends ProductSelector {
  // Color name mappings for special characters
  // static COLOR_MAPPINGS = {
  //   'Weiß': 'Weiss',
  //   'Grün': 'Grun',
  //   'Türkis': 'Turkis'
  // };

  constructor() {
    super();

    this.productMedia = document.querySelector('product-media');
    this.productMediaSlider = this.productMedia.querySelector('[data-slider]');
  }

  /**
   * Connected callback - override to handle initial color filtering
   */
  connectedCallback() {
    super.connectedCallback();

    // Ensure currentVariant is set from the initially selected options
    this.updateVariant();

    // Wait for product-media to be initialized, then filter by initial color
    if (!this.productMediaSlider) {
      return;
    }

    this.initializeColorFilter();
  }

  /**
   * Initialize color filter on page load
   */
  initializeColorFilter() {
    // Check if slider is ready, or wait for ready event
    const applyInitialFilter = () => {
      if (!this.productMedia.isReady()) {
        // Wait for ready event or check again
        this.productMedia.addEventListener('product-media-ready', applyInitialFilter, { once: true });
        setTimeout(() => {
          if (this.productMedia.isReady()) {
            applyInitialFilter();
          }
        }, 100);
        return;
      }

      // Find the initially selected color swatch
      const selectedColorInput = this.querySelector('input[data-type="color"]:checked');
      if (selectedColorInput && selectedColorInput.value) {
        // Filter by the initially selected color
        this.filterMediaByColor(selectedColorInput.value);
        // After filtering completes, navigate to the correct variant image
        // Small delay to ensure sliders are reinitialized
        setTimeout(() => {
          this.updateMedia();
        }, 60);
      } else {
        // Even if no color filter, ensure variant image is shown
        this.updateMedia();
      }
    };

    // Try immediately first
    if (!this.productMediaSlider) {
      return;
    }

    if (this.productMedia.isReady()) {
      applyInitialFilter();
    } else {
      // Wait for ready event
      this.productMedia.addEventListener('product-media-ready', applyInitialFilter, { once: true });
      // Fallback timeout in case event doesn't fire
      setTimeout(applyInitialFilter, 500);
    }
  }

  /**
   * On variant change.
   * Slider is always synced to the selected color (from the form), so it updates
   * even when the current variant is unavailable (e.g. Taupe/37 missing, then size 39).
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);

    if (this.currentVariant) {
      this.updateURL();
    }

    if (event.target.type === 'number') {
      return;
    }

    if (!this.productMediaSlider) {
      return;
    }

    // Sync slider to currently selected color (so it updates even when variant is unavailable)
    const selectedColorInput = this.querySelector('input[data-type="color"]:checked');
    const selectedColor = selectedColorInput?.value;

    if (selectedColor) {
      this.filterMediaByColor(selectedColor);
    }

    // Navigate to variant image when we have one
    if (this.currentVariant?.featured_media) {
      setTimeout(() => {
        this.updateMedia();
      }, selectedColor ? 60 : 0);
    }
  }

  /**
   * Filter media by selected color swatch
   *
   * @param {String} colorValue - The color value from the swatch
   * @returns {Void}
   */
  filterMediaByColor(colorValue) {
    if (!this.productMedia || !colorValue) {
      return;
    }

    // Normalize color name using mapping if needed
    // colorValue = MainProductSelector.COLOR_MAPPINGS[colorValue] || colorValue;

    this.productMedia.filterMediaByColor(colorValue);
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    this.productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
